// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1q9D4","delete":"styles_delete__COtC4","update":"styles_update__3NhXM","add":"styles_add__3jrLr"};